// extracted by mini-css-extract-plugin
module.exports = {"chatsLoading":"Chats_chatsLoading__9u0XS"};